export default {
  headerContainer: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 40
  },
  pageTitle: {
    margin: "30px 0px"
  },
  paymentHistoryTable: {
    borderBottom: "2px solid #ddd"
  },
  paymentHistoryTableDataCell: {
    verticalAlign: "middle",
    padding: "2vh 10px"
  },
  paymentHistoryTableDataCellRightBound: {
    textAlign: "right",
    verticalAlign: "middle",
    padding: "2vh 10px"
  },
  paymentHistoryTableHeaderCentered: {
    textAlign: "center"
  },
  paymentHistoryTableHeaderRightBound: {
    textAlign: "right"
  },
  paymentHistoryDetaildescriptionList: {
    padding: "10px"
  }
};
